import { OrderProfanityCheckStatus } from "@/types/order"
import axios from "./orderInstance"
import { toast } from "react-toastify"
export default async (orderId: string,orderItemId: string, section: string,neatolabsCost:number) => {
  const payload = {
    "operation" : "update_section",
    "values":{
      "neatolabs_cost":Number(neatolabsCost),
      "section":section
    }
  };

  try {
    const response: any = await axios.patch(`/orders/${orderId}/line-items/${orderItemId}`, payload);
    toast.success('Line Item changed successfully');
    return response.data
  } catch (error) {
    return null
  }
}
